import { PromptTemplateCategory } from '../types';

export const creative: PromptTemplateCategory = {
  title: "创意",
  icon: "✨",
  templates: [
    {
      title: "睡前故事",
      content: `为幼儿创作一个温柔的睡前故事，适合朗读。
- 主角是一只[善良的小狐狸]，名叫[榛子]。
- 故事发生在[一个温馨的林间小村庄，夜晚灯笼闪烁]。
- 角色面临一个小小的、令人安心的挑战：[她在多云的夜空中找不到她最爱的星星，于是跟着萤火虫走到了山顶]。
- 以一个平和的结局结束，教导[耐心，以及相信美好的事物一直都在，即使你暂时看不到它们]。
- 使用简短、有节奏的句子，朗读时听起来自然流畅。`
    },
    {
      title: "短篇小说叙述",
      content: `写一篇适合有声书风格叙述的短篇小说。
- 类型：[当代悬疑]。
- 主角是[一位退休的图书管理员，她注意到新邻居的日常行为有些古怪]。
- 核心张力是[微小的、无法解释的细节逐渐累积，走向一个令人惊讶但满意的揭示]。
- 基调：[安静的悬念中带有温暖]。
- 用清晰流畅的风格写作，变化句子长度以保持听众的兴趣。`
    },
    {
      title: "诗歌朗诵",
      content: `写一首适合朗诵的诗歌。
- 主题：[城市黎明时分苏醒的感觉]。
- 风格：[自由诗，带有自然的口语节奏]。
- 情绪：[沉思而充满希望]。
- 包含生动的感官细节：[第一班公交车的声音、阳光照在湿漉漉的路面上、面包店飘来新鲜面包的香气]。
- 使用停顿和换行来引导朗读者的节奏和呼吸。`
    }
  ]
};
